import { CartSegment, DashboardOrderDetailsGridData } from "../lib/types";
import { LineItem } from "./line-item";

type RowProps = {
  row: DashboardOrderDetailsGridData["uniqueLines"][number];
  selectedSegment: CartSegment;
};

export function Row({ row, selectedSegment }: RowProps) {
  return (
    <div className="flex border-b">
      <div className="w-1/3 min-w-1/3 border-r align-top py-2 px-0">
        {selectedSegment === CartSegment.OrderLines ? (
          <LineItem line={row.orderLine} />
        ) : (
          <LineItem line={row.annotatedLine} />
        )}
      </div>
      <div className="w-1/3 min-w-1/3 border-r align-top py-2 px-0">
        <LineItem
          line={row.zoneBasedPredictionLine}
          isQuantityDifferent={
            row.zoneBasedPredictionLine &&
            row.annotatedLine &&
            row.zoneBasedPredictionLine.quantity !== row.annotatedLine.quantity
          }
        />
      </div>
      <div className="w-1/3 min-w-1/3 py-2 align-top px-0">
        <LineItem
          line={row.pinBasedPredictionLine}
          isQuantityDifferent={
            row.pinBasedPredictionLine &&
            row.annotatedLine &&
            row.pinBasedPredictionLine.quantity !== row.annotatedLine.quantity
          }
        />
      </div>
    </div>
  );
}
